import React, { Dispatch, useMemo } from 'react';
import classes from './PostEvergreenFilterGroup.module.scss';
import { PostScheduleFilterAction } from '../../../models/post';
import { PostScheduleViewContext } from '../../../modules/Publish/PostSchedule/PostSchedule.controller';
import { FilterItemGroup } from '../FilterItemGroup';
import { FilterItem } from '../FilterItem';
import { PostQueueCountResult, QueueFilterPostEvergreen } from '../../../models/graphql';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';
import classNames from 'classnames';
import { Tooltip } from '../../actions/Tooltip';
import scssVars from '../../../assets/scss/exportedVars.module.scss';

export type PostEvergreenFilterGroupViewProps = {
  loading: boolean;
  dispatchFilters: Dispatch<PostScheduleFilterAction>;
  activeFilterId?: string;
  context: PostScheduleViewContext;
  recurringSelected?: boolean;
  queueCounts: PostQueueCountResult;
};

export const PostEvergreenFilterGroupView = (props: PostEvergreenFilterGroupViewProps): JSX.Element => {
  const { queueCounts } = props; // useContext(QueueCountContext);
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'evergreen', payload: { data: id, fetchPosts: true } });
  };

  const counts = useMemo(() => PostScheduleHelpers.getQueueCounts(queueCounts, 'evergreen'), [queueCounts]);

  const labelClasses = classNames(classes.Label, {
    [classes.LabelDisabled]: props.recurringSelected
  });

  return (
    <FilterItemGroup title={'Filter By Evergreen Status'}>
      <>
        <FilterItem
          selected={props.activeFilterId === QueueFilterPostEvergreen.EVERGREEN_ONLY}
          count={counts.evergreenOnly}
          loading={props.loading}
          isEvergreen={true}
          setSelectedHandler={() => setSelectedFilter(QueueFilterPostEvergreen.EVERGREEN_ONLY)}
          disabled={props.recurringSelected}>
          <div id={'Evergreen-Filter-Label'}>
            <div className={labelClasses}>
              Evergreen Only
              {props.recurringSelected && (
                <Tooltip
                  type={'inlined'}
                  target={'#Evergreen-Filter-Label'}
                  position={'right'}
                  pointer
                  autoZIndex={false}
                  style={{ zIndex: scssVars['z-index-overmodal'] }}>
                  <div>This filter is not available when viewing Recurring Posts</div>
                </Tooltip>
              )}
            </div>
          </div>
        </FilterItem>
      </>
    </FilterItemGroup>
  );
};
